import { render, staticRenderFns } from "./CostTableBodyRow.vue?vue&type=template&id=b97f5110&scoped=true&"
import script from "./CostTableBodyRow.vue?vue&type=script&lang=js&"
export * from "./CostTableBodyRow.vue?vue&type=script&lang=js&"
import style0 from "./CostTableBodyRow.vue?vue&type=style&index=0&id=b97f5110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97f5110",
  null
  
)

export default component.exports